module.exports = __webpack_public_path__ + "img/medal.b83374c1.png";